export const executeCallbacks = (callbacks, props, onError) => {
    return async (...params) => {
        return callbacks.reduce(async (data, func) => {
            const next = await data

            try {
                const response =
                    params?.[0]?.name === 'CANCEL'
                        ? await func({props})
                        : await func(...params, props, next)

                return {...next, ...response}
            } catch (error) {
                if (typeof onError === 'function') {
                    await onError(error)
                }

                throw error
            }
        }, Promise.resolve({}))
    }
}
